export default "__VITE_ASSET__a5de7c23__"